import { useContext } from 'react';
import { CursosComplementaresContext } from './cursos-complementares.provider';
import { Hook } from './cursos-complementares.types';

export const useCursosComplementares: Hook = () => {
  const context = useContext(CursosComplementaresContext);

  if (context) {
    return context;
  }

  throw new Error('Contexto de cursos complementares indefinido, verifique local da utilização');
};
